import script from "./InfractionContestationsTermsOfUsePage.vue?vue&type=script&setup=true&lang=js"
export * from "./InfractionContestationsTermsOfUsePage.vue?vue&type=script&setup=true&lang=js"

import "./InfractionContestationsTermsOfUsePage.vue?vue&type=style&index=0&id=1cd373e7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cd373e7"]])

export default __exports__